var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _assertThisInitialized = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var Base = require('./Base');

var Audience = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(Audience, _Base);

  var _super = _createSuper(Audience);

  function Audience() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? '' : _ref$id,
        _ref$campaignId = _ref.campaignId,
        campaignId = _ref$campaignId === void 0 ? null : _ref$campaignId,
        _ref$version = _ref.version,
        version = _ref$version === void 0 ? '1' : _ref$version,
        _ref$inputs = _ref.inputs,
        inputs = _ref$inputs === void 0 ? {} : _ref$inputs,
        _ref$owner = _ref.owner,
        owner = _ref$owner === void 0 ? '' : _ref$owner,
        _ref$created = _ref.created,
        created = _ref$created === void 0 ? null : _ref$created,
        _ref$modified = _ref.modified,
        modified = _ref$modified === void 0 ? null : _ref$modified,
        _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        _ref$pricingBoundsCPM = _ref.pricingBoundsCPMUserInput,
        pricingBoundsCPMUserInput = _ref$pricingBoundsCPM === void 0 ? null : _ref$pricingBoundsCPM,
        _ref$description = _ref.description,
        description = _ref$description === void 0 ? '' : _ref$description,
        _ref$archived = _ref.archived,
        archived = _ref$archived === void 0 ? false : _ref$archived,
        _ref$temp = _ref.temp,
        temp = _ref$temp === void 0 ? {} : _ref$temp;

    _classCallCheck(this, Audience);

    _this = _super.call(this);
    _this.id = id;
    _this.campaignId = campaignId;
    _this.version = version;
    _this.inputs = inputs;
    _this.owner = owner;
    _this.created = created;
    _this.modified = modified;
    _this.title = title;
    _this.pricingBoundsCPMUserInput = pricingBoundsCPMUserInput;
    _this.description = description;
    _this.archived = archived;
    _this.temp = temp;
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Audience, [{
    key: "marketAdd",
    get: function get() {
      return this.deepCopyObj({
        campaignId: this.campaignId,
        version: this.version,
        inputs: this.inputs,
        title: this.title,
        pricingBoundsCPMUserInput: this.pricingBoundsCPMUserInput
      });
    }
  }, {
    key: "marketDbAdd",
    get: function get() {
      return this.deepCopyObj({
        campaignId: this.campaignId,
        version: this.version,
        inputs: this.inputs,
        title: this.title,
        pricingBoundsCPMUserInput: this.pricingBoundsCPMUserInput,
        owner: this.owner,
        created: this.created
      });
    }
  }, {
    key: "marketDbUpdate",
    get: function get() {
      return this.deepCopyObj({
        version: this.version,
        inputs: this.inputs,
        title: this.title,
        archived: this.archived,
        modified: this.modified
      });
    }
  }, {
    key: "marketUpdate",
    get: function get() {
      return this.deepCopyObj({
        version: this.version,
        inputs: this.inputs,
        title: this.title,
        archived: this.archived
      });
    }
  }]);

  return Audience;
}(Base);

module.exports = Audience;